import { MARKETING_IMG } from './marketing-utils';

/**
 * Immobilienportale, auf denen ein Locari-Inserat erscheint – EINE Quelle für
 * alle Logo-Leisten (Preis-Seite, WG-/Concierge-Landingpages, Design-System).
 * Basis = Kleinanzeigen; Plus = zusätzlich ImmoScout24.
 */
export type PortalLogo = {
  src: string;
  alt: string;
};

export const PORTAL_LOGOS_BASIS: PortalLogo[] = [
  { src: `${MARKETING_IMG}/logos/kleinanzeigen.svg`, alt: 'Kleinanzeigen' },
];

export const PORTAL_LOGOS_PLUS: PortalLogo[] = [
  {
    src: `${MARKETING_IMG}/logos/portals/immoscout24-wide.svg`,
    alt: 'ImmoScout24',
  },
  { src: `${MARKETING_IMG}/logos/kleinanzeigen.svg`, alt: 'Kleinanzeigen' },
];
